@if (isLoading) {
  <div class="loading">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<ng-container *transloco="let t; read: 'widgets.interactive-smart-summary'">
  @if (!isLoading) {
    <div class="xi-modal__container interactive-smart-summary__container">
      <ng-container>
        <h2 class="xi-modal__title">
          {{ t('dialog-header-no-sentiment', { selectedItem: options.pointName }) }}
        </h2>
        @if (isLoading) {
          <div class="interactive-smart-summary__loader">
            <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
          </div>
        }
        @if (!isLoading && isError) {
          <div class="interactive-smart-summary__error">
            <p>{{ t('error-generating-summaries') }}</p>
          </div>
        }
        <!-- SMART SUMMARY MAIN SECTION -->
        @if (!isLoading && !isError) {
          <div
            class="xi-modal__content xi-modal__content--start interactive-smart-summary__content"
          >
            <div class="interactive-smart-summary__summary-wrapper">
              @if (dataSource?.data?.length === 0) {
                <div class="interactive-smart-summary__empty-selection">
                  {{ t('no-nodes-defined') }}
                </div>
              } @else {
                <div class="interactive-smart-summary__summary-tree-wrapper">
                  <mat-tree
                    [dataSource]="summaryDataSource"
                    [treeControl]="treeControl"
                    class="interactive-smart-summary__summary-tree"
                    cdkDropList
                  >
                    <mat-nested-tree-node
                      *matTreeNodeDef="let node; when: displayExpandable"
                      cdkDropList
                    >
                      <div
                        (click)="onSummaryNodeClicked(node)"
                        [attr.data-node-uuid]="node.uuid"
                        class="interactive-smart-summary__row"
                        [class.interactive-smart-summary__row--selected]="selectedNode === node"
                      >
                        <button
                          mat-icon-button
                          class="interactive-smart-summary__row-expand-button"
                          (click)="toggleAndSelectNode($event, node)"
                        >
                          <mat-icon class="mat-icon-rtl-mirror">
                            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                          </mat-icon>
                        </button>
                        <ng-template
                          *ngTemplateOutlet="summaryNavigationRow; context: { $implicit: node }"
                        >
                        </ng-template>
                      </div>
                      @if (treeControl.isExpanded(node)) {
                        <div
                          [class.interactive-smart-summary__row--collapsed]="
                            !treeControl.isExpanded(node)
                          "
                          role="group"
                        >
                          <ng-container matTreeNodeOutlet></ng-container>
                        </div>
                      }
                    </mat-nested-tree-node>
                  </mat-tree>
                  <ng-template #summaryNavigationRow let-item>
                    <div class="interactive-smart-summary__target-name">
                      {{ item.name }}
                    </div>
                  </ng-template>
                </div>
              }
              <div class="interactive-smart-summary__summary-section">
                <mat-drawer-container class="interactive-smart-summary__drawer-container">
                  <div class="interactive-smart-summary__drawer-main-content">
                    <div class="interactive-smart-summary__drawer-main-content-summaries">
                      <div class="summaries-top-info">
                        <div class="breakdown-language">
                          @if (options.isDebug) {
                            <div class="similarity-dropdown">
                              <xi-input-field
                                label="{{ t('similarity-label') }}"
                                [tooltip]="{ text: similarityToolTip }"
                                [disabled]="similarityChanging"
                                (onInputEnter)="onSimilarityChange($event.detail.text, true)"
                                name="similaritySelector"
                                [ngModel]="similarity"
                                type="number"
                              ></xi-input-field>
                            </div>
                          }
                          <div>
                            <xi-dropdown
                              [placeholder]="t('select-breakdown')"
                              [data]="breakdownDropDownData"
                              select="single"
                              label="{{ t('select-breakdown') }}"
                              [tooltip]="{ text: breakdownToolTip }"
                              [(value)]="breakdownField"
                              [disabled]="
                                !selectedNode.isTopLevel ||
                                isLoadingBreakdown ||
                                options.isDashboardLocked
                              "
                              (onValueChange)="onBreakdownBreakdownFieldChange($event)"
                            ></xi-dropdown>
                          </div>
                          <div class="toplevel-button">
                            <xi-icon-button
                              color="system"
                              type="button"
                              [buttonSize]="small"
                              [disabled]="
                                selectedNode.isBreakdown ||
                                isLoadingSummary ||
                                options.isDashboardLocked
                              "
                              [tooltip]="{ text: t('generate-new-summary') }"
                              icon="fab_plus"
                              (onClick)="generateSummary()"
                            ></xi-icon-button>
                          </div>
                          @if (options.isDebug) {
                            <div class="toplevel-button">
                              <xi-icon-button
                                color="system"
                                type="button"
                                [tooltip]="{ text: downloadEmbeddingReportTooltip }"
                                [buttonSize]="small"
                                icon="tag_filled"
                                [disabled]="currentlyDownloadingEmbeddingReport"
                                (onClick)="downloadEmbeddingDocs()"
                              ></xi-icon-button>
                            </div>
                          }
                        </div>
                      </div>
                      @for (summary of selectedNode.summaries; track summary) {
                        <div class="summary-entry">
                          @if (!summary.regenerating) {
                            <div class="summary-text">
                              <p class="bold">{{ summary.header ? summary.header : '' }}</p>
                              @if (isFeatureSummaryItemDropdownButtonsImplemented) {
                                <div>
                                  <app-smart-summary-text
                                    [smartSummary]="summary"
                                    [menuTemplate]="hyperLinkTemplate"
                                    [tooltipText]="
                                      options?.widgetDataSource?.type === 'group'
                                        ? 'widgets.interactive-smart-summary.no-drill-for-ag'
                                        : ''
                                    "
                                  ></app-smart-summary-text>
                                </div>
                              } @else {
                                <p>{{ summary.summary }}</p>
                              }
                            </div>
                          }
                          @if (summary.regenerating) {
                            <div class="summary-text">
                              <p>{{ t('regenerating') }}</p>
                            </div>
                          }
                          <div class="summary-actions">
                            <div class="summary-actions-buttons">
                              @if (options.isDebug) {
                                <div>
                                  <xi-icon-button
                                    color="system"
                                    type="button"
                                    [tooltip]="{ text: summary.downloadEmbeddingReportTooltip }"
                                    [buttonSize]="small"
                                    icon="arrow_down"
                                    [disabled]="summary.currentlyDownloadingEmbeddingReport"
                                    (onClick)="downloadSummaryEmbeddingDocs(summary)"
                                  ></xi-icon-button>
                                </div>
                              }
                              <xi-icon-button
                                color="system"
                                type="button"
                                [buttonSize]="small"
                                [tooltip]="{ text: t('example-verbatims-tooltip') }"
                                icon="app_data_exploration"
                                (onClick)="generateExamples(summary)"
                              ></xi-icon-button>
                              @if (options.isDashboardLocked) {
                                <ng-container
                                  *ngTemplateOutlet="
                                    kabobButtonTemplate;
                                    context: { isDisabled: true }
                                  "
                                ></ng-container>
                              } @else {
                                <div
                                  [matMenuTriggerFor]="summaryMenuTrigger"
                                  [matMenuTriggerData]="{ summary: summary }"
                                >
                                  <ng-container
                                    *ngTemplateOutlet="kabobButtonTemplate"
                                  ></ng-container>
                                </div>
                              }

                              <ng-template #kabobButtonTemplate let-isDisabled>
                                <xi-icon-button
                                  color="system"
                                  type="button"
                                  [buttonSize]="small"
                                  [disabled]="isDisabled"
                                  icon="kabob"
                                ></xi-icon-button>
                              </ng-template>
                            </div>
                            <div class="summary-actions-pill">
                              <span [matTooltip]="summary.countToolTip">
                                <xi-custom-pill text="{{ summary.percentage }}%"></xi-custom-pill>
                              </span>
                            </div>
                            @if (summary.breakdownValue) {
                              <div class="summary-actions-pill">
                                <span [matTooltip]="summary.breakdownValue">
                                  <xi-custom-pill [text]="summary.breakdownValue | truncate: 10">
                                  </xi-custom-pill>
                                </span>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                    <mat-drawer
                      #drawer
                      class="interactive-smart-summary__drawer"
                      mode="side"
                      position="end"
                    >
                      <ng-container *ngTemplateOutlet="drawerContent"></ng-container>
                    </mat-drawer>
                  </div>
                </mat-drawer-container>
              </div>
            </div>
          </div>
        }
        <div class="xi-modal__actions interactive-smart-summary__cancel">
          <xi-default-button
            [text]="t('close')"
            fill="text"
            (onClick)="confirm()"
          ></xi-default-button>
        </div>
      </ng-container>
    </div>
  }

  <!-- SMART SUMMARY 3-DOT MENU -->
  <mat-menu #summaryMenuTrigger class="menu-with-xi-icons" xPosition="before">
    <ng-template matMenuContent let-summary="summary">
      <button
        [disabled]="summary.regenerating || summary.isErrored || isLoadingSummary"
        mat-menu-item
        (click)="regenerateSummary(summary)"
      >
        <xi-icon color="orca" icon="convert"></xi-icon>
        <div>{{ t('regenerate') }}</div>
      </button>
      @if (summary.breakdownValue) {
        <button
          [disabled]="summary.isErrored || isLoadingSummary"
          mat-menu-item
          (click)="generateSummary(summary)"
        >
          <xi-icon color="orca" icon="convert"></xi-icon>
          <div>{{ t('generate-new-summary') }}</div>
        </button>
      }

      <div [matTooltip]="summaryFeedbackTooltip">
        <button
          [disabled]="summary.currentlyGeneratingFeedback"
          mat-menu-item
          (click)="leaveSummaryFeedback(summary)"
        >
          <xi-icon color="orca" icon="feedback"></xi-icon>
          @if (!summary.feedbackId) {
            <div>{{ t('leave-insight-feedback') }}</div>
          }
          @if (summary.feedbackId) {
            <div>{{ t('update-insight-feedback') }}</div>
          }
        </button>
      </div>

      @if (summary.feedbackId) {
        <div>
          <button
            [disabled]="summary.currentlyGeneratingFeedback"
            mat-menu-item
            (click)="removeSummaryFeedback(summary)"
          >
            <xi-icon color="orca" icon="email_remove"></xi-icon>
            <div>{{ t('remove-insight-feedback') }}</div>
          </button>
        </div>
      }

      <button mat-menu-item (click)="copyToClipBoard(summary)">
        <xi-icon color="orca" icon="clipboard"></xi-icon>
        <div>{{ t('copy-to-clipboard') }}</div>
      </button>

      <div [matTooltip]="addCommentTooltip">
        <button [disabled]="!options.canAddComment" mat-menu-item (click)="addAsComment(summary)">
          <xi-icon color="orca" icon="comment"></xi-icon>
          <div>{{ t('add-as-comment') }}</div>
        </button>
      </div>

      <div [matTooltip]="addNotesTooltip">
        <button [disabled]="options.isReadOnly" mat-menu-item (click)="addAsNoteWidget(summary)">
          <xi-icon color="orca" icon="add_circle"></xi-icon>
          <div>{{ t('add-as-note') }}</div>
        </button>
      </div>

      <span [matTooltip]="summary.disableRemoveTooltip">
        <button
          mat-menu-item
          [disabled]="summary.disableRemove || isLoadingSummary"
          (click)="removeSummary(summary)"
        >
          <xi-icon color="orca" icon="cancel_18"></xi-icon>
          <div>{{ t('remove-summary') }}</div>
        </button>
      </span>

      <span [matTooltip]="summary.downloadRequestTooltip">
        <button
          [disabled]="summary.currentlyDownloadingSpotERequest"
          mat-menu-item
          (click)="downloadSpotERequest(summary)"
        >
          <xi-icon color="orca" icon="download"></xi-icon>
          <div>{{ t('download-spote-request') }}</div>
        </button>
      </span>

      @if (options.isDebug) {
        <button mat-menu-item (click)="analyzeSummary(summary)">
          <xi-icon color="orca" icon="clipboard"></xi-icon>
          <div>{{ t('analyze-summary') }}</div>
        </button>
      }
    </ng-template>
  </mat-menu>

  <mat-menu class="menu-with-xi-icons" #hyperLinkTemplate xPosition="before">
    <button mat-menu-item disabled>
      <xi-icon color="orca" icon="preview"></xi-icon>
      <div>{{ t('show-example-documents') }}</div>
    </button>
    @if (options?.widgetDataSource?.type !== 'group') {
      <button mat-menu-item disabled>
        <xi-icon color="orca" icon="visibility"></xi-icon>
        <div>{{ t('drill-down') }}</div>
      </button>
    }
  </mat-menu>
</ng-container>

<!-- LEFT HAND TREE -->

<!-- DUMMY DATASOURCE DISPLAY -->
<ng-template #dataSourceAndFilters>
  <ng-container *transloco="let t; read: 'widgets.interactive-smart-summary'">
    <div class="datasource-filters-chip">
      <mat-chip-listbox>
        <mat-chip-option [disabled]="true">
          <xi-icon icon="folder" color="system" size="small"></xi-icon>

          <span class="datasource-display-name">
            @if (truncateName) {
              <span [matTooltip]="datasourceDisplayName">
                {{ datasourceDisplayName | truncate }}
              </span>
            } @else {
              {{ datasourceDisplayName }}
            }
          </span>

          &nbsp;
          <small class="datasource-docs">
            {{
              t('numberof-docs', {
                count: (dataSourceDocumentCount | humanizeInt: 1 : 1000),
              })
            }}
            |
          </small>
          <xi-icon icon="filter_filled" color="system" size="small"></xi-icon>

          &nbsp;
          <small class="datasource-filtered-docs">
            {{
              t('filtered-docs', {
                count: (filteredDocumentCount | humanizeInt: 1 : 1000),
              })
            }}
          </small>
        </mat-chip-option>
      </mat-chip-listbox>
    </div>
  </ng-container>
</ng-template>

<!-- RIGHT HAND SIDE -->
<ng-template #drawerContent>
  <ng-container *transloco="let t; read: 'widgets.interactive-smart-summary'">
    <div class="right-panel__header-container">
      <xi-horizontal-tab-bar
        [data]="rightPanelTabs"
        [tabSpacing]="15"
        color="orca"
        [(activeTabId)]="activeTab"
      ></xi-horizontal-tab-bar>
    </div>
    @if (!isLoading) {
      <div
        [ngClass]="
          activeTab === 'examples'
            ? 'right-panel__tab-content--display'
            : 'right-panel__tab-content--hide'
        "
      >
        @if (!selectedSummary) {
          <div>
            <p>{{ t('no-summary-selected') }}</p>
          </div>
        }
        @if (selectedSummary && examplesLoading && !selectedSummary.examplesRequested) {
          <div>
            <p>{{ t('examples-loading') }}</p>
          </div>
        }
        @if (selectedSummary && !examplesLoading && !selectedSummary.examplesRequested) {
          <div class="margin-left-text">
            <br />
            <div class="kxi-text-center">
              <xi-icon-button
                color="system"
                type="button"
                [buttonSize]="small"
                icon="app_data_exploration"
              ></xi-icon-button>
            </div>
            <p>{{ t('example-verbatims-empty') }}</p>
          </div>
        }
        @if (
          selectedSummary &&
          selectedSummary.examplesRequested &&
          selectedSummary.examples.length < 1 &&
          !selectedSummary.ignoredExamples
        ) {
          <div class="margin-left-text">
            <p>{{ t('example-verbatims-not-found') }}</p>
          </div>
        }
        @if (
          selectedSummary &&
          selectedSummary.examplesRequested &&
          (selectedSummary.examples.length > 0 || selectedSummary.ignoredExamples)
        ) {
          <ng-continer>
            <div class="margin-left-text">
              <p>{{ t('example-verbatims-for') }}</p>
            </div>
            <div>
              <div class="margin-left-text">
                <p class="example-section-header">
                  {{ selectedSummary.header ?? selectedSummary.exampleSectionHeader }}...
                </p>
              </div>
              <div>
                <xi-icon-button
                  color="system"
                  type="button"
                  [buttonSize]="small"
                  [disabled]="selectedSummary.examplesExhausted || isLoadingExample"
                  [tooltip]="{ text: selectedSummary.anotherExampleTooltip }"
                  (onClick)="getAnotherExample()"
                  icon="fab_plus"
                ></xi-icon-button>
              </div>
            </div>
          </ng-continer>
        }
        @for (example of selectedSummary?.examples ?? []; track example) {
          <div class="example-verbatim xi-loader-container">
            @if (isProcessingExample(example)) {
              <div
                class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur"
              >
                <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
              </div>
            }
            <div class="verbatim-topbar">
              <div class="example-header">{{ example.header }}</div>
              <div
                [matMenuTriggerFor]="exampleMenuTrigger"
                [matMenuTriggerData]="{ example: example }"
              >
                <xi-icon-button
                  color="system"
                  type="button"
                  [buttonSize]="small"
                  icon="kabob"
                ></xi-icon-button>
              </div>
            </div>
            @if (example.fetchingAnother) {
              <div>
                <p>{{ t('example-fetching-another') }}</p>
              </div>
            }
            @if (!example.fetchingAnother) {
              <div>
                <p>{{ example.text }}</p>
              </div>
            }
          </div>
        }
      </div>
    }

    <!-- VERBATIM EXAMPLE 3-DOT MENU-->
    <mat-menu #exampleMenuTrigger class="menu-with-xi-icons">
      <ng-template matMenuContent let-example="example">
        <button mat-menu-item (click)="copyExampleToClipboard(example)">
          <xi-icon color="orca" icon="clipboard"></xi-icon>
          <div>{{ t('copy-to-clipboard') }}</div>
        </button>

        <div [matTooltip]="addTagsTooltip">
          <button
            [disabled]="options.isReadOnly"
            mat-menu-item
            (click)="tagExampleDocument(example)"
          >
            <xi-icon color="orca" icon="tag"></xi-icon>
            <div>{{ t('tag-this-document') }}</div>
          </button>
        </div>

        <button mat-menu-item (click)="removeExample(example)">
          <xi-icon color="orca" icon="cancel_18"></xi-icon>
          <div>{{ t('remove-example') }}</div>
        </button>
      </ng-template>
    </mat-menu>
  </ng-container>
</ng-template>

@if (showAddDocumentTagsModal) {
  <app-lex-xi-modal
    [isVisible]="showAddDocumentTagsModal"
    [canBackdropClose]="false"
    maxWidth="600px"
    (close)="onDocumentTagClosed()"
  >
    <ng-template appXIModalContent>
      @if (showAddDocumentTagsModal) {
        <app-add-tags-dialog
          [options]="documentTagsModalOptions"
          (modalClosed)="onDocumentTagClosed($event)"
        ></app-add-tags-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
@if (showSmartSummaryFeedbackModal) {
  <app-lex-xi-modal
    [isVisible]="showSmartSummaryFeedbackModal"
    [canBackdropClose]="false"
    maxWidth="600px"
    (close)="onSummaryFeedbackClosed()"
  >
    <ng-template appXIModalContent>
      @if (showSmartSummaryFeedbackModal) {
        <app-smart-summary-feedback-dialog
          [currentFeedback]="currentFeedback"
          (modalClosed)="onSummaryFeedbackClosed($event)"
        ></app-smart-summary-feedback-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
